import React from "react";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import { ButtonContainer } from "../styles/StyledComponents";

const StepNavigation = ({
  activeStep,
  totalSteps,
  onBack,
  onNext,
  isNextDisabled,
}) => {
  const isLastStep = activeStep === totalSteps - 1;

  return (
    <ButtonContainer>
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={activeStep === 0}
        startIcon={<ArrowBackIcon />}
        sx={{
          borderColor: "#ff9800",
          color: "#ff6f00",
          "&:hover": {
            borderColor: "#ff6f00",
            backgroundColor: "rgba(255, 152, 0, 0.08)",
          },
        }}
      >
        Indietro
      </Button>
      <Button
        variant="contained"
        onClick={onNext}
        disabled={isNextDisabled}
        startIcon={isLastStep ? <SaveRoundedIcon /> : null}
        endIcon={isLastStep ? null : <ArrowForwardIcon />}
        sx={{
          backgroundColor: isLastStep ? "#4caf50" : "#ff9800",
          "&:hover": {
            backgroundColor: isLastStep ? "#388e3c" : "#ff6f00",
          },
          "&.Mui-disabled": {
            backgroundColor: (theme) =>
              theme.palette.mode === "light" ? "#e0e0e0" : "#4a4a4a",
            color: (theme) =>
              theme.palette.mode === "light"
                ? "rgba(0, 0, 0, 0.26)"
                : "rgba(255, 255, 255, 0.3)",
          },
        }}
      >
        {isLastStep ? "Salva Preventivo" : "Avanti"}
      </Button>
    </ButtonContainer>
  );
};

export default StepNavigation;
